var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCampaignCount = function SvgCampaignCount(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "campaign",
    transform: "translate(-670.97)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_278",
    "data-name": "Rectangle 278",
    width: 24,
    height: 24,
    transform: "translate(670.97)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "campaign_FILL0_wght300_GRAD-25_opsz20",
    d: "M117.841-755.676a.613.613,0,0,1-.444-.2.611.611,0,0,1-.2-.442.61.61,0,0,1,.2-.442.613.613,0,0,1,.444-.2h1.716a.608.608,0,0,1,.44.2.608.608,0,0,1,.2.44.612.612,0,0,1-.2.444.609.609,0,0,1-.44.2Zm-.2,5.18-1.372-1.009a.686.686,0,0,1-.252-.43.547.547,0,0,1,.132-.469.775.775,0,0,1,.44-.247.522.522,0,0,1,.46.117l1.372,1a.7.7,0,0,1,.252.435.548.548,0,0,1-.131.469.778.778,0,0,1-.441.246A.523.523,0,0,1,117.639-750.5Zm-.625-9.65a.507.507,0,0,1-.45.117.765.765,0,0,1-.43-.247.53.53,0,0,1-.126-.466.753.753,0,0,1,.257-.437l1.362-1.026a.507.507,0,0,1,.45-.117.768.768,0,0,1,.431.247.53.53,0,0,1,.126.466.745.745,0,0,1-.254.434Zm-10.465,9.2v-3.273h-.764a1.711,1.711,0,0,1-1.11-.391,1.243,1.243,0,0,1-.482-1.012v-1.394a1.264,1.264,0,0,1,.482-1.023,1.693,1.693,0,0,1,1.108-.4H108.8l2.543-1.517a.707.707,0,0,1,.766-.032.7.7,0,0,1,.386.663v5.983a.707.707,0,0,1-.387.669.7.7,0,0,1-.765-.036l-2.543-1.513h-.975v3.273ZM108.344-756.316Zm5.631,2.581v-5.174a3.131,3.131,0,0,1,.776,1.111,3.716,3.716,0,0,1,.286,1.476,3.716,3.716,0,0,1-.286,1.476A3.131,3.131,0,0,1,113.975-753.736Zm-2.756-.514v-4.129l-2,1.224h-3.49a.25.25,0,0,0-.18.082.25.25,0,0,0-.082.18v1.14a.25.25,0,0,0,.082.18.251.251,0,0,0,.18.082h3.49Z",
    transform: "translate(570.807 768.35)",
    fill: "var(--hyperlink )"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCampaignCount, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/campaignCount.71b137d8.svg";
export { ForwardRef as ReactComponent };